/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetBreedSizeModel } from './PetBreedSizeModel';
import {
    PetBreedSizeModelFromJSON,
    PetBreedSizeModelFromJSONTyped,
    PetBreedSizeModelToJSON,
} from './PetBreedSizeModel';
import type { PetTypeReferenceModel } from './PetTypeReferenceModel';
import {
    PetTypeReferenceModelFromJSON,
    PetTypeReferenceModelFromJSONTyped,
    PetTypeReferenceModelToJSON,
} from './PetTypeReferenceModel';
import type { SubmitterModel } from './SubmitterModel';
import {
    SubmitterModelFromJSON,
    SubmitterModelFromJSONTyped,
    SubmitterModelToJSON,
} from './SubmitterModel';

/**
 * 
 * @export
 * @interface PetBreedModel
 */
export interface PetBreedModel {
    /**
     * 
     * @type {number}
     * @memberof PetBreedModel
     */
    id: number;
    /**
     * 
     * @type {SubmitterModel}
     * @memberof PetBreedModel
     */
    submitter?: SubmitterModel;
    /**
     * 
     * @type {string}
     * @memberof PetBreedModel
     */
    name: string;
    /**
     * Only modifiable during update.
     * @type {boolean}
     * @memberof PetBreedModel
     */
    markForDelete?: boolean;
    /**
     * 
     * @type {PetBreedSizeModel}
     * @memberof PetBreedModel
     */
    size?: PetBreedSizeModel;
    /**
     * 
     * @type {PetTypeReferenceModel}
     * @memberof PetBreedModel
     */
    type: PetTypeReferenceModel;
}

/**
 * Check if a given object implements the PetBreedModel interface.
 */
export function instanceOfPetBreedModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function PetBreedModelFromJSON(json: any): PetBreedModel {
    return PetBreedModelFromJSONTyped(json, false);
}

export function PetBreedModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetBreedModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'submitter': !exists(json, 'submitter') ? undefined : SubmitterModelFromJSON(json['submitter']),
        'name': json['name'],
        'markForDelete': !exists(json, 'markForDelete') ? undefined : json['markForDelete'],
        'size': !exists(json, 'size') ? undefined : PetBreedSizeModelFromJSON(json['size']),
        'type': PetTypeReferenceModelFromJSON(json['type']),
    };
}

export function PetBreedModelToJSON(value?: PetBreedModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'submitter': SubmitterModelToJSON(value.submitter),
        'name': value.name,
        'markForDelete': value.markForDelete,
        'size': PetBreedSizeModelToJSON(value.size),
        'type': PetTypeReferenceModelToJSON(value.type),
    };
}

